import { Components } from '@mui/material';

export default {
  styleOverrides: { root: { '& .MuiFormControlLabel-label': { fontSize: '14px' } } },
} as Components;
